import { ArrayUtil } from '../utils/array.util';

export class TNode {
	find(arg0: (node: any) => boolean) {
		throw new Error('Method not implemented.');
	}
    id: number;
    x: number;
    y: number;
    dxMp_Id: number;
    totalChildNodes: number;
    childNodes: Array<number>;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.id = -1;
        this.x = 100;
        this.y = 100;
        this.dxMp_Id = -1;
        this.totalChildNodes = 0;
        this.childNodes = new Array<number>();
    }

    static parse(tNodeTmp: TNode): TNode {
        let tNode: TNode = new TNode();
        tNode.copyFrom(tNodeTmp);
        return tNode;
    }

    copy(): TNode {
        let tnodeTmp: TNode = new TNode();

        tnodeTmp.id = this.id;
        tnodeTmp.x = this.x;
        tnodeTmp.y = this.y;
        tnodeTmp.dxMp_Id = this.dxMp_Id;
        tnodeTmp.totalChildNodes = this.totalChildNodes;
        tnodeTmp.childNodes = ArrayUtil.getInstance().copy(this.childNodes);

        return tnodeTmp
    }

    copyFrom(tNodeTmp: TNode): void {
        this.id = tNodeTmp.id;
        this.x = tNodeTmp.x;
        this.y = tNodeTmp.y;
        this.dxMp_Id = tNodeTmp.dxMp_Id;
        this.totalChildNodes = tNodeTmp.totalChildNodes;
        ArrayUtil.getInstance().copyFrom(this.childNodes, tNodeTmp.childNodes);
    }

    compare(tNodeTmp: TNode): string {
        let tNodeString: string = this.toString();
        let tNodeTmpString: string = tNodeTmp.toString();

        if (tNodeString != tNodeTmpString) {
            return tNodeString + ', ' + tNodeTmpString;
        }

        return '';
    }

    toString(): string {
        return "TNode [id=" + this.id + ", x=" + this.x + ", y=" + this.y +
            ", dxMp_Id=" + this.dxMp_Id + ", totalChildNodes=" + this.totalChildNodes +
            ", childNodes=" + ArrayUtil.getInstance().toString(this.childNodes) + "]";
    }
}